var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 52,
    viewBox: "0 0 72 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H72V52H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#DA1C5C"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M7.35.016L26.77 0C28 0 29 .933 29 2.085v13.55c0 1.15-.999 2.084-2.23 2.084H2.23C1 17.719 0 16.785 0 15.634v-9.17",
    transform: "translate(15 2) translate(12.094 19.625)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2.313 6.234L25.938 6.234M7.234 2.625L7.234 16.406",
    transform: "translate(15 2) translate(12.094 19.625)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.936 6.408c1.029-.09 1.694-.29 1.997-.597.454-.461.507-1.156.117-1.551-.389-.396-1.072-.342-1.526.119-.303.308-.499.984-.588 2.029zM6.936 6.538c.09 1.045.285 1.72.588 2.028.454.462 1.137.515 1.526.12.39-.396.337-1.09-.117-1.552-.303-.307-.968-.506-1.997-.596zM6.56 6.538c-.09 1.045-.285 1.72-.588 2.028-.454.462-1.138.515-1.527.12-.39-.396-.336-1.09.118-1.552.302-.307.968-.506 1.996-.596z",
    transform: "translate(15 2) translate(12.094 19.625)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.5 9.516L23.313 9.516M11.5 11.813L23.313 11.813M11.5 14.109L18.719 14.109",
    transform: "translate(15 2) translate(12.094 19.625)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DA1C5C",
    strokeLinecap: "round",
    d: "M25 40.012v5.113C25 46.16 24.139 47 23.077 47H1.923C.861 47 0 46.16 0 45.125V1.875C0 .84.861 0 1.923 0h21.154C24.139 0 25 .84 25 1.875v14.69",
    transform: "translate(15 2)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#DA1C5C",
    strokeLinecap: "round",
    d: "M17.813 1c0 .853-.407 1.545-.91 1.545H6.91C6.407 2.545 6 1.853 6 1",
    transform: "translate(15 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15 2) translate(4 10)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.891,
    cy: 6.891,
    r: 6.891,
    fill: "#DA1C5C"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 0.2,
    d: "M9.16 5.656h-.97c-.055-.535-.344-1.031-.766-1.337H9.16c.105 0 .19-.086.19-.19 0-.106-.085-.191-.19-.191H5.12c-.105 0-.191.085-.191.19s.086.191.19.191h1.158c.786 0 1.436.592 1.53 1.337H5.12c-.105 0-.191.086-.191.19 0 .106.086.192.19.192h2.687c-.095.773-.752 1.354-1.53 1.355H5.123c-.107.002-.193.09-.191.197 0 .052.023.101.059.138l2.889 2.732c.076.072.196.069.269-.008.073-.078.069-.198-.008-.273L5.6 7.775h.676c.997 0 1.82-.763 1.915-1.737h.97c.105 0 .19-.086.19-.191 0-.105-.085-.191-.19-.191z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#DA1C5C",
    strokeLinecap: "round",
    d: "M6 44.328L17.813 44.328",
    transform: "translate(15 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard2);
export default __webpack_public_path__ + "static/media/giftCard2.f471e9e6686a060d2682ea7ca8bd855e.svg";
export { ForwardRef as ReactComponent };